// extracted by mini-css-extract-plugin
export default {"chips":"ChipsGroup-module__chips__o65vv","chip":"ChipsGroup-module__chip__LrqBW"};